import { render, staticRenderFns } from "./GB28181.vue?vue&type=template&id=65a80c8c&"
import script from "./GB28181.vue?vue&type=script&lang=js&"
export * from "./GB28181.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports